import {apiAuth} from '../../../services/ApiService'
import {createRequest} from '../../../helpers/RequestHelper'

export function salvarDadosCertificado(data, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'POST', path: '/certificados/modelo', data: data, onSuccess, onError
    });
}

export function atualizarDadosCertificado(data, id, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'PUT', path: `/certificados/modelo/${id}`, data: data, onSuccess, onError
    });
}

export function downloadModeloCertificado(id, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: `/certificados/modelo/${id}/download`, onSuccess, onError
    });
}

export function salvarFormulario(data, onSuccess, onError) {
    //data.adminCpf = getCPF();
    return createRequest({
        api: apiAuth, method: 'POST', path: '/forms/', data: data, onSuccess, onError
    });
}

export function editarFormulario(id, data, onSuccess, onError) {
    //data.adminCpf = getCPF();
    return createRequest({
        api: apiAuth, method: 'PUT', path: '/forms/'+id, data: data, onSuccess, onError
    });
}

export function getDadosFixosCertificado(idDadosFixos, onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: '/certificados/fixos/'+idDadosFixos, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/certificados/fixos?idForm={idForm}&idCampo={idCampo
export function salvarDadosVariaveisCertificado(data, idSub, idCampo, onSuccess, onError) {
    const path = `/certificados?sub=${idSub}&campo=${idCampo}`
    return createRequest({
        api: apiAuth, method: 'POST', path: path, data: data, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/certificados/dados?sub={idSub}&campo={idCampo}
export function recuperarDadosVariaveisCertificado(idSub, idCampo, onSuccess, onError) {
    const path = `/certificados/dados?sub=${idSub}&campo=${idCampo}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function recuperarDadosCertificadoDaSubmissao(idSub, onSuccess, onError) {
    const path = `/certificados/dados/submissao/${idSub}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}


// http://192.168.24.119:9000/api/certificados/dados?sub={idSub}&campo={idCampo}
export function apagarDadosVariaveisCertificado(idDadosCertificado, onSuccess, onError) {
    const path = `/certificados/dados/${idDadosCertificado}`
    return createRequest({
        api: apiAuth, method: 'DELETE', path: path, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/submits/boleto/servicos
export function buscarServicoDeBoleto(id = null,onSuccess, onError) {
    const path = `/submits/boleto/servicos`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/certificados/fixos?idForm=101&idCampo=
export function temCertificado(idForm, onSuccess, onError) {
    const path = `/certificados/fixos?idForm=${idForm}&idCampo=`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

// http://192.168.24.119:9000/api/certificados/fixos?idForm=101&idCampo=1
export function campoDeCertificadoPreenchido(idForm, idCampo, onSuccess, onError) {
    const path = `/certificados/fixos?idForm=${idForm}&idCampo=${idCampo}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function buscarModelosCertificadoPorForm(url, idForm, onSuccess, onError) {
    const path = `${url}&idForm=${idForm}`
    return createRequest({
        api: apiAuth, method: 'GET', path: path, onSuccess, onError
    });
}

export function deletarModeloCertificado(idModelo, onSuccess, onError) {
    const path = `/certificados/modelos?idModelo=${idModelo}`
    return createRequest({
        api: apiAuth, method: 'DELETE', path: path, onSuccess, onError
    });
}

//############# Reducers actions #################

export function addItem(item){
    return{
        type: 'ADD_ITEM',
        payload: item
    }
}

export function deleteItem(id){
    return{
        type: 'DELETE_ITEM',
        payload: id
    }
}

export function updateItem(id){
    return{
        type: 'UPDATE_ITEM',
        payload: id
    }
}

export function updateTitulo(titulo){
    return{
        type: 'UPDATE_TITULO',
        payload: titulo
    }
}

export function updateDescricao(descricao){
    return{
        type: 'UPDATE_DESCRICAO',
        payload: descricao
    }
}

export function updateState(newState){
    return{
        type: 'UPDATE_STATE',
        payload: newState
    }
}

export function resetState(){
    return{
        type: 'RESET_STATE'
    }
}

export function upCampo(item){
    return{
        type: 'UP_CAMPO',
        payload: item
    }
}

export function downCampo(item){
    return{
        type: 'DOWN_CAMPO',
        payload: item
    }
}

export function updatePermissao(permissao){
    return{
        type: 'UPDATE_PERMISSAO',
        payload: permissao
    }
}

export function updateDataValidade(dataValidade){
    return{
        type: 'UPDATE_DATA_VALIDADE',
        payload: dataValidade
    }
}

export function updateDataInicio(dataInicio){
    return{
        type: 'UPDATE_DATA_INICIO',
        payload: dataInicio
    }
}

export function updateTemCertificado(temCertificado){
    return{
        type: 'UPDATE_TEM_CERTIFICADO',
        payload: temCertificado
    }
}

export function updateLimiteDeInscritos(limiteDeInscritos){
    return{
        type: 'UPDATE_LIMITE_DE_INSCRITOS',
        payload: limiteDeInscritos
    }
}

export function updateValorBoleto(valorBoleto){
    return{
        type: 'UPDATE_VALOR_BOLETO',
        payload: valorBoleto
    }
}

export function updateDataLimiteBoleto(dataLimiteBoleto){
    return{
        type: 'UPDATE_DATA_LIMITE_BOLETO',
        payload: dataLimiteBoleto
    }
}

export function updateResubmissao(resubmissao){
    return{
        type: 'UPDATE_RESUBMISSAO',
        payload: resubmissao
    }
}
export function updateServicoBoleto(servicoBoleto){
    return{
        type: 'UPDATE_SERVICO_BOLETO',
        payload: servicoBoleto
    }
}

export function updateEvento(temEvento){
    return{
        type: 'UPDATE_EVENTO',
        payload: temEvento
    }
}

export function updateConfirmarPorEmail(temEmail){
    return{
        type: 'UPDATE_CONFIRMAR_POR_EMAIL',
        payload: temEmail
    }
}

export function buscarCustoDoBoleto(onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: '/forms/custo', onSuccess, onError
    });
}

export function updateInterno(interno){
    return{
        type: 'UPDATE_INTERNO',
        payload: interno
    }
}

export function updateTemBoleto(temBoleto) {
    return {
        type: 'UPDATE_TEM_BOLETO',
        payload: temBoleto
    }
}

// lembrar de tirar
export function downloadCertificado(onSuccess, onError) {
    return createRequest({
        api: apiAuth, method: 'GET', path: '/certificados/download2', onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/formulario/actions/FormBuilderActions.js